import React, {useState} from "react";
import { EMOJI, IEmoji } from "./Emoji";
import { UrlPreview } from "./UrlPreview";

const urlMetadata = require('url-metadata');

export interface IMessage {

    Identifier: string;
    IsInbound: boolean;
    Channel : IMessageChannel;
    To: IMessageReceiver;
    From: IMessageSender;
    Timestamp : Date;
    Delay: number;
    Valid?:boolean;
}

export interface IMessageChannel {

}

export interface IMessageReceiver {

}

export interface IMessageSender {

}

export interface IMessageProps extends IMessage {
    
    children : string|JSX.Element[]|JSX.Element|null;
}

export const REGEX_IS_LINK = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&\/=]*)/g;
/*OLD: /(([a-z]+:\/\/)?(([a-z0-9\-]+\.)+([a-z]{2}|aero|arpa|biz|com|coop|edu|gov|info|int|jobs|mil|museum|name|nato|net|org|pro|travel|local|internal))(:[0-9]{1,5})?(\/[a-z0-9_\-\.~]+)*(\/([a-z0-9_\-\.]*)(\?[a-z0-9+_\-\.%=&amp;]*)?)?(#[a-zA-Z0-9!$&'()*+.=-_~:@/?]*)?)(\s+|$)/gi;*/



export const MessageTextConverter = {

    parse : (text: string) => {

        return (text as any)
            .replaceAll('\r\n','\n') //replace all cr lf to lf
            .replaceAll('\r','\n') //replace all cr to lf
            .split('\n') //split all lf
            .map(   (v,i,a) => { 
                        
                        //console.log("before reduce",{v:v});

                        var wasLetter : boolean = false;

                        let txt = [...v].reduce( (accumulator, letter) => 
                        {
                            accumulator = accumulator === undefined ? [] : accumulator;
                            accumulator = accumulator ? accumulator : [];

                            var isLetter = !(EMOJI.find( (emoji:IEmoji) => emoji.icon === letter ));

                            //console.log("reduce",{accumulator:accumulator, latter:letter, wasLetter:wasLetter, isLetter:isLetter});

                            if(isLetter) 
                            {
                                if(wasLetter) 
                                {
                                    var prevText = accumulator[accumulator.length-1];
                                    var prevIsLink = prevText.text.match(REGEX_IS_LINK);
                                    var newText = prevText.text + letter;
                                    var newIsLink = newText.match(REGEX_IS_LINK); 

                                    if(newIsLink && !prevIsLink) {

                                        //clean the part of the prevText that is now part of the link
                                        let prevTextText = prevText.text.slice(0, prevText.text.length - newIsLink[0].length);

                                        
                                        newText = newIsLink[0];

                                        //console.log("prevTextText",{prevText:prevText, prevTextText:prevTextText, newText:newText, newIsLink:newIsLink[0]});
                                        
                                        if(newText.startsWith(prevTextText)) {
                                           
                                            //the link is being made longer while it was invalid before
                                            accumulator[accumulator.length-1] = {element:<UrlPreview  key={accumulator.length-1}  link={newText}/>, text: newText}

                                        } else {
                                            accumulator[accumulator.length-1] = {element: <span  key={accumulator.length-1} >{prevTextText}</span>, text:prevTextText}
                                            //start a new entry for the link
                                            accumulator[accumulator.length] = {element:<UrlPreview  key={accumulator.length}  link={newText}/>, text: newText}

                                        }
                                    } else if(newIsLink && prevIsLink) {
                                        //make the old link longer
                                       

                                        newText = newIsLink[0];
                                        // console.log("both are link", newText);
                                        accumulator[accumulator.length-1] = {element:<UrlPreview key={accumulator.length-1}  link={newText}/>, text: newText}

                                    } else {
                                        //plain text
                                        accumulator[accumulator.length-1] = {element: <span  key={accumulator.length-1} >{newText}</span>, text:newText};
                                    }

                                    //if(prevIsLink || newIsLink) {
                                    //    console.log("Link",{prevText: prevText, newText: newText, prevIsLink:prevIsLink, newIsLink:newIsLink});
                                    //}

                                    
                                } else {
                                    accumulator[accumulator.length] = {element:<span  key={accumulator.length} >{letter}</span>, text:letter};
                                }
                                wasLetter = true;
                            } else {

                                wasLetter = false;
                                accumulator[accumulator.length] = {element : <span key={accumulator.length} className='emoji'>{letter}</span>, text: letter};
                            }

                            return accumulator;

                          },[] );//end of reduce
                   

                    txt = txt.filter(t=>t.text !==' ');

                    let elements = txt.map(item => item.element);

                    
                    //console.log("end reduce",{v:v, txt:txt});

                    return <span key={i}>{ elements } {i !== a.length - 1 ? <br/> : null}
                           </span>

                    //<>{ 
                    //    /*i == a.length - 1 
                    //                    ? txt.map( (al,idx) => {al.element}</div>)
                    //                    : <>{txt.map( (al, idx) => <div key={idx}>{al.element}</div>)}<br/></>
                    //     */       }
                    //        </> ;
                    } //end of map
                );
    
    }
}

export const Message = (props:IMessageProps) => {

   
    const [timestamp] = useState<Date>(new Date(props.Timestamp));
    const [classes] = useState(props.IsInbound?"mr-message mr-message-inbound":"mr-message mr-message-outbound");
    const timestampText = ('0'+timestamp.getHours()).slice(-2) +':'+  ('0' + timestamp.getMinutes()).slice(-2);
    return <div className={classes +' '+ props["$type"].replaceAll('.','-').replaceAll(',','').toLowerCase()}><div className="mr-message-handle"></div><div>{props.children}</div><span className="mr-message-time">{timestampText}</span></div>;

}